module.exports = __webpack_public_path__ + "static/media/PrestigeEliteStd.ffd35be5.otf";